export class Job {
    constructor() {
        this.profession = null;
    }

    _id: string; // Import Ref: id
    job_id: number; // Import Ref: ref_no_c
    name: string; // Also used in import labeled as job_title_description_c
    city: string; // Import Ref: city_c
    state: string; // Import Ref: state2_c
    zip: string; // Import Ref: zip_code_c
    marketing_video: string; // Import Ref: marketing_video
    job_status: string; // Import Ref: job_status_c
    job_id_old: string; // Import Ref: ref_no_old_c
    profession: string; // Also used in import labeled as occupation_c, job_category_web_c, and job_title_description_c
    job_type: string; // Import Ref: job_types/job_type
    setting: string; // Import Ref: setting_c
    featured_job: boolean; // Import Ref: featured_job_c (1 or 0)
    short_job_description: string; // Import Ref: short_job_description_web_c
    long_job_description: string; // Import Ref: long_job_description_web_c
    location: {
        latitude: number;
        longitude: number;
    };
    locationInfo: any; // Relate
    isCurrent: boolean;
    urlParts: {
        profession: string;
        state: string;
        city: string;
    };
    market: any;
    compensation_min: number;
    compensation_max: number;
    compensation_interval: string; // e.g. "hourly", "weekly", "monthly", "yearly"
    compensation_currency: string;
    deleted: boolean;
    createdAt: Date; // Also used in import labeled as date_entered
    updatedAt: Date;

    // Meta feed admin overrides
    district?: string;
    startDate?: Date;
    schoolYear?: string;
    isSignOnBonus?: boolean;
    feedDescription?: string;
    excludeFromMetaFeed?: boolean;
    heroImageTemplate?: any;
    heroImage?: {
        url: string;
        hash: string;
        generatedAt: Date;
    };
    professions: any; // For job-search filter
    states: any; // For job-search filter
    hasSearchTerms; // For filters
    dateCreatedRange; // For filters
    dateCreated; // For filters
    dateCreatedEnd; // For filters
    googleFormattedAddress: string; // Address to display in google auto complete to see what was searched last
    googlePlaceLocation: {
        latitude: number;
        longitude: number;
    };
    googlePlaceAutoCompleteResult: any; // To use for getting jobs and sort by google auto complete location result
    message; // for paged results
    pageSize;
    pageNumber;
    limitTo: number;
}